export default {"src":"/uk/_next/static/media/spot-village.df7286b0.svg","height":120,"width":120,"blurWidth":0,"blurHeight":0};